// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"db5de882","306":"b554e8ee","453":"ec6583bb","657":"29a530ba"}[chunkId] + ".chunk.js";
};